import { defineStore } from 'pinia';
import api from '@/Services/api';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        notifications: [],
        loading: false,
        error: null,
    }),
    getters: {
        unreadCount: (state) => state.notifications.filter(n => !n.is_read).length,
        sortedNotifications: (state) => {
            return [...state.notifications].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
    },
    actions: {
        async fetchNotifications() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get('/notifications/');
                this.notifications = response.data;
            } catch (err) {
                this.error = "Failed to load notifications";
                console.error(err);
            } finally {
                this.loading = false;
            }
        },

        async markAsRead(notificationId) {
            try {
                await api.patch(`/notifications/${notificationId}/read`);
                const notification = this.notifications.find(n => n.id === notificationId || n._id === notificationId);
                if (notification) notification.is_read = true;
            } catch (err) {
                console.error('Error marking notification as read:', err);
            }
        },

        async deleteNotification(notificationId) {
            try {
                await api.delete(`/notifications/${notificationId}`);
                this.notifications = this.notifications.filter(n => (n.id || n._id) !== notificationId);
            } catch (err) {
                console.error('Error deleting notification:', err);
            }
        },

        async markAllAsRead() {
            // Simplified: loop through unread and mark them
            const unread = this.notifications.filter(n => !n.is_read);
            for (const n of unread) {
                await this.markAsRead(n.id || n._id);
            }
        }
    },
});
